exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-register {\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-position: center center;\r\n    height: 100%;\r\n    width: 100%;\r\n    padding: 10% 0;\r\n    position: fixed; }\r\n  \r\n  .login-box {\r\n    width: 400px;\r\n    margin: 0 auto; }\r\n    .login-box .footer {\r\n      width: 100%;\r\n      left: 0px;\r\n      right: 0px; }\r\n    .login-box .social {\r\n      display: block;\r\n      margin-bottom: 30px; }\r\n  \r\n  #recoverform {\r\n    display: none; }\r\n  \r\n  .login-sidebar {\r\n    padding: 0px;\r\n    margin-top: 0px; }\r\n    .login-sidebar .login-box {\r\n      right: 0px;\r\n      position: absolute;\r\n      height: 100%; }\r\n  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/auth/login.component.css
// module id = ../../../../../src/app/auth/login.component.css
// module chunks = main